import { type AxiosRequestConfig } from 'axios'
import {defaultHttpClient as axios} from '@anypromo/shared/api/_HttpClient'

import { ApMessageBox } from '@anypromo/components-pc'

let requestSeq = 0

export type AjaxResult<T> = {
  Code: number
  Msg: string
  Data?: T
}

export const apiPost = <T>(
  url: string,
  params: any,
  config?: AxiosRequestConfig
): Promise<AjaxResult<T>> => {
  const sessionGuid = (window as any).sessionGuid
  requestSeq++
  return new Promise((resolve, reject) => {
    axios
      .post(
        url + `&sessionGuid=${sessionGuid}&requestSeq=${requestSeq}`,
        params,
        config
      )
      .then((res) => {
        const data = res.data
        if (data.Code !== 200) {
          // return data.Data
          if (data.Code === 409) {
            ApMessageBox.open({
              title: ' ',
              message: data.Msg
                ? data.Msg
                : 'Sorry, your session has expired. Please refresh this page to start again.',
              confirmButtonText: 'Refresh',
              allowHtml: true
            }).then((data: any) => {
              window.location.reload()
            })
            resolve(data)
          } else if (data.code === 401) {
            // 需要登录，弹出登录窗口
            reject(data)
          } else {
            reject(data)
          }
        } else {
          resolve(data)
        }
      })
  })
}

export const apiPostWithForm = <T>(
  url: string,
  params: any
): Promise<AjaxResult<T>> => {
  //
  return apiPost<T>(url, params, {
    transformRequest: [
      function (data) {
        /**
         * 在执行请求之前，把请求由 Json 的格式处理成 K-V 的形式
         */
        let ret = ''
        for (const it in data) {
          ret +=
            encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function apiGet<T>(
  url: string,
  seqUp = true
): Promise<AjaxResult<T>> {
  const sessionGuid = (window as any).sessionGuid
  if (seqUp) {
    requestSeq++
  }
  return new Promise((resolve, reject) => {
    axios
      .get(url + `&sessionGuid=${sessionGuid}&requestSeq=${requestSeq}`)
      .then((res) => {
        const data = res.data
        if (data.Code !== 200) {
          // return data.Data
          if (data.Code === 409) {
            ApMessageBox.open({
              title: ' ',
              message: data.Msg
                ? data.Msg
                : 'Sorry, your session has expired. Please refresh this page to start again.',
              confirmButtonText: 'Refresh',
              allowHtml: true
            }).then((data: any) => {
              window.location.reload()
            })
            resolve(data)
          } else if (data.code === 401) {
            // 需要登录，弹出登录窗口
            reject(data)
          } else {
            reject(data)
          }
        } else {
          resolve(data)
        }
      })
  })
}
export type CalcDeliveryOption = {
  ProductID: number
  TransitTime?: number
  Eta?: any
  ProductionList: number[]
}

const deliveryCache: Record<string, string[]> = {}

export function calcDelivery(options: CalcDeliveryOption): Promise<any> {
  return new Promise((resolve, reject) => {
    const cacheKey = options.ProductionList.join(',') + options.Eta
    if (deliveryCache[cacheKey]) {
      resolve(deliveryCache[cacheKey])
    } else {
      const params = {
        ...options
      }
      axios
        .post('/ajax/ProductDetail.aspx/GetDeliveryDateRange', params)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.d) {
              deliveryCache[cacheKey] = res.data.d
              if (Array.isArray(options.ProductionList)) {
                options.ProductionList.forEach((p: number, index: number) => {
                  const tcacheKey = p + options.Eta
                  deliveryCache[tcacheKey] = [res.data.d[index]]
                })
                deliveryCache[cacheKey] = res.data.d
              }
              resolve(deliveryCache[cacheKey])
            } else {
            }
          }
        })
    }
  })
}
